import { STUDENT_COMPETENCY_STATUS } from '../../../resources/studentCompetencyStatus';
import CompetencyRequestListPageActionTypes from './competency-request-list-page-action-types';
import axios from 'axios';

export const loadCompetencyRequestListPage = (payload) => async(dispatch, getState) => {
  const state = getState().competencyRequestListPage;
  if (!state.studyProgramsComboBoxData) {
    await dispatch(filterStudyProgramsComboBox({ includeWithId: payload?.searchParams?.get('studyProgramId') }));
  }
  if (!state.residentsComboBoxData) {
    await dispatch(filterResidentsComboBox({ includeWithId: payload?.searchParams?.get('studentId') }));
  }
  dispatch(findCompetencyRequests(payload));
};

export const findCompetencyRequests = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: CompetencyRequestListPageActionTypes.LOAD_COMPETENCY_REQUEST_LIST_START });
  const state = getState().competencyRequestListPage;
  let query;
  if (payload?.searchParams?.size > 0) {
    query = Object.fromEntries(payload.searchParams.entries());
    dispatch(saveQueryParamsToStore(query));
  } else {
    query = {
      skip: payload?.skip ?? state.skip,
      limit: payload?.take ?? state.take,
      studyProgramId: state.filter?.studyProgram?.id,
      studentId: state.filter?.resident?.id,
      status: state.filter?.status?.value
    };
  }
  try {
    state.competencyRequestsCancelToken?.cancel();
    state.competencyRequestsCancelToken = axios.CancelToken.source();
    const competencyRequests = await api.get(`api/competency_requests`, query, state.competencyRequestsCancelToken.token);
    dispatch({
      type: CompetencyRequestListPageActionTypes.LOAD_COMPETENCY_REQUEST_LIST_END,
      payload: {
        competencyRequests: competencyRequests?.data?.map(item => ({
          ...item,
          isSelected: false
        })),
        total: competencyRequests ? competencyRequests.total : 0,
        skip: payload?.skip ?? state.skip,
        take: payload?.take ?? state.take
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: CompetencyRequestListPageActionTypes.LOAD_COMPETENCY_REQUEST_LIST_END });
      throw error;
    }
  }
};

export const filterCompetencyRequests = (payload) => (dispatch, getState) => {
  dispatch({
    type: CompetencyRequestListPageActionTypes.FILTER_COMPETENCY_REQUEST_LIST,
    payload: payload
  });
  const state = getState().competencyRequestListPage;
  if (state.selectedAll) {
    dispatch(selectAllCompetencyRequestList());
  }
  dispatch(findCompetencyRequests());
};

export const clearCompetencyRequestsFilter = () => (dispatch, getState) => {
  dispatch({
    type: CompetencyRequestListPageActionTypes.FILTER_COMPETENCY_REQUEST_LIST,
    payload: {}
  });
  const state = getState().competencyRequestListPage;
  if (state.selectedAll) {
    dispatch(selectAllCompetencyRequestList());
  }
  dispatch(findCompetencyRequests());
};

export const filterStudyProgramsComboBox = payload => async(dispatch, getState, { api }) => {
  dispatch({ type: CompetencyRequestListPageActionTypes.SEARCH_STUDY_PROGRAMS_COMBOBOX_START });
  const parsedInclude = parseInt(payload?.includeWithId);
  const query = {
    skip: 0,
    take: 50,
    keyword: payload?.keyword,
    includeWithId: isNaN(parsedInclude) ? null : parsedInclude
  };
  const state = getState().competencyRequestListPage;
  try {
    state.studyProgramsComboBoxCancelToken?.cancel();
    state.studyProgramsComboBoxCancelToken = axios.CancelToken.source();
    const studyPrograms = await api.get(`api/study_programs`, query, state.studyProgramsComboBoxCancelToken.token);
    dispatch({
      type: CompetencyRequestListPageActionTypes.SEARCH_STUDY_PROGRAMS_COMBOBOX_END,
      payload: {
        studyPrograms: studyPrograms?.data ?? []
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: CompetencyRequestListPageActionTypes.SEARCH_STUDY_PROGRAMS_COMBOBOX_END });
      throw error;
    }
  }
};

export const filterResidentsComboBox = payload => async(dispatch, getState, { api }) => {
  dispatch({ type: CompetencyRequestListPageActionTypes.SEARCH_RESIDENTS_COMBOBOX_START });
  const parsedInclude = parseInt(payload?.includeWithId);
  const query = {
    skip: 0,
    take: 50,
    keyword: payload?.keyword,
    includeWithId: isNaN(parsedInclude) ? null : parsedInclude
  };
  const state = getState().competencyRequestListPage;
  try {
    state.residentsComboBoxCancelToken?.cancel();
    state.residentsComboBoxCancelToken = axios.CancelToken.source();
    const residents = await api.get(`api/students`, query, state.residentsComboBoxCancelToken.token);
    dispatch({
      type: CompetencyRequestListPageActionTypes.SEARCH_RESIDENTS_COMBOBOX_END,
      payload: {
        residents: residents?.data?.map(element => ({ id: element.id, name: element.firstName + ' ' + element.lastName })) ?? []
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: CompetencyRequestListPageActionTypes.SEARCH_RESIDENTS_COMBOBOX_END });
      throw error;
    }
  }
};

export const selectCompetencyRequestList = (payload) => (dispatch, getState) => {
  const state = getState().competencyRequestListPage;
  const selectedCompetencies = [];
  let competencyRequests = [];
  let selectedAll = true;
  if (!state.competencyRequests) {
    selectedAll = false;
  }
  competencyRequests = state.competencyRequests.map(competencyRequest => {
    let isSelected = competencyRequest.isSelected;
    if (competencyRequest.id === payload.id) {
      isSelected = !isSelected;
    }
    if (isSelected) {
      selectedCompetencies.push(competencyRequest);
    } else {
      selectedAll = false;
    }
    return {
      ...competencyRequest,
      isSelected
    };
  });
  dispatch({
    type: CompetencyRequestListPageActionTypes.SELECT_COMPETENCY_REQUEST_LIST,
    payload: {
      competencyRequests,
      selectedCompetencies,
      selectedAll
    }
  });
};

export const selectAllCompetencyRequestList = () => (dispatch, getState) => {
  const state = getState().competencyRequestListPage;
  const selectedCompetencies = [];
  const competencyRequests = state.competencyRequests?.map(competencyRequest => {
    const isSelected = !state.selectedAll && [STUDENT_COMPETENCY_STATUS.TO_BE_APPROVED, STUDENT_COMPETENCY_STATUS.TO_BE_SIGNED, STUDENT_COMPETENCY_STATUS.ACQUIRED, STUDENT_COMPETENCY_STATUS.SENDING_ERROR].includes(competencyRequest.status);
    if (isSelected) {
      selectedCompetencies.push(competencyRequest);
    }
    return {
      ...competencyRequest,
      isSelected
    };
  });
  dispatch({
    type: CompetencyRequestListPageActionTypes.SELECT_ALL_COMPETENCY_REQUEST_LIST,
    payload: {
      competencyRequests,
      selectedCompetencies
    }
  });
};

export const initMultiSign = ({ userId }) => async(dispatch, getState, { api }) => {
  dispatch({ type: CompetencyRequestListPageActionTypes.INIT_MULTI_SIGN_START });
  const state = getState().competencyRequestListPage;
  const selectedIds = [];
  state.selectedCompetencies.map(competency => {
    if (competency.approvingUserId === userId && [STUDENT_COMPETENCY_STATUS.TO_BE_APPROVED, STUDENT_COMPETENCY_STATUS.TO_BE_SIGNED].includes(competency.status)) {
      selectedIds.push(competency.id);
    }
  });
  try {
    state.competencyRequestsCancelToken?.cancel();
    state.competencyRequestsCancelToken = axios.CancelToken.source();

    const queryParams = [];
    state.filter?.keyword && queryParams.push(`keyword=${state.filter.keyword}`);
    state.filter?.studyProgram?.id && queryParams.push(`studyProgramId=${state.filter.studyProgram.id}`);
    state.filter?.resident?.id && queryParams.push(`studentId=${state.filter.resident.id}`);

    const signingRedirectUrl = await api.post(`api/student_competencies/init_multi_sign`, selectedIds, state.competencyRequestsCancelToken.token, undefined, { queryParams });
    dispatch({
      type: CompetencyRequestListPageActionTypes.INIT_MULTI_SIGN_END,
      payload: { signingRedirectUrl }
    });
    if (state.selectedAll) {
      dispatch(selectAllCompetencyRequestList());
    }
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: CompetencyRequestListPageActionTypes.INIT_MULTI_SIGN_END });
      throw error;
    }
  }
};

export const toggleConfirmDialog = (payload) => async(dispatch, getState) => {
  if (!payload) {
    dispatch({
      type: CompetencyRequestListPageActionTypes.TOGGLE_CONFIRM_DIALOG
    });
  } else {
    const { localizationService, confirmDialogActionText, confirmDialogFunction, statusesForActionValidation, userIdForActionValidation } = payload;
    const state = getState().competencyRequestListPage;
    const selectedCount = state.selectedCompetencies.length;
    let validSelectedCount;
    let confirmDialogText;

    if (localizationService && statusesForActionValidation) {
      validSelectedCount = state.selectedCompetencies.reduce((counter, competency) => statusesForActionValidation.includes(competency.status) && (!userIdForActionValidation || competency.approvingUserId === userIdForActionValidation) ? ++counter : counter, 0);
      if (validSelectedCount === 0) {
        confirmDialogText = localizationService.toLanguageString('competencyRequest.confirmDialogMessageTemplateForNone').replace('{0}', confirmDialogActionText);
      } else if (selectedCount === validSelectedCount) {
        confirmDialogText = localizationService.toLanguageString('competencyRequest.confirmDialogMessageTemplateForAll').replace('{0}', confirmDialogActionText);
      } else if (selectedCount > validSelectedCount) {
        confirmDialogText = localizationService.toLanguageString('competencyRequest.confirmDialogMessageTemplateForSome').replace('{0}', validSelectedCount).replace('{1}', selectedCount).replace('{2}', confirmDialogActionText);
      }
    }

    dispatch({
      type: CompetencyRequestListPageActionTypes.TOGGLE_CONFIRM_DIALOG,
      payload: {
        confirmDialogFunction,
        confirmDialogText,
        isConfirmButtonDisabled: validSelectedCount === 0
      }
    });
  }
};

export const sendCompetencyCertificates = () => async(dispatch, getState, { api }) => {
  dispatch({ type: CompetencyRequestListPageActionTypes.SEND_COMPETENCY_CERTIFICATE_START });
  const state = getState().competencyRequestListPage;
  const selectedIds = [];
  state.selectedCompetencies.map(competency => {
    if ([STUDENT_COMPETENCY_STATUS.ACQUIRED, STUDENT_COMPETENCY_STATUS.SENDING_ERROR].includes(competency.status)) {
      selectedIds.push(competency.id);
    }
  });
  try {
    state.competencyRequestsCancelToken?.cancel();
    state.competencyRequestsCancelToken = axios.CancelToken.source();
    await api.post(`api/student_competency_certificate/send`, selectedIds, state.competencyRequestsCancelToken.token);
    dispatch({ type: CompetencyRequestListPageActionTypes.SEND_COMPETENCY_CERTIFICATE_END });
    dispatch(findCompetencyRequests());
    if (state.selectedAll) {
      dispatch(selectAllCompetencyRequestList());
    }
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: CompetencyRequestListPageActionTypes.SEND_COMPETENCY_CERTIFICATE_END });
      throw error;
    }
  }
};

export const saveQueryParamsToStore = (payload) => async(dispatch, getState) => {
  const state = getState().competencyRequestListPage;
  const queryParams = {
    filter: {
      keyword: payload.keyword,
      studyProgram: state.studyProgramsComboBoxData?.find(e => e.id == payload.studyProgramId),
      resident: state.residentsComboBoxData?.find(e => e.id == payload.studentId)
    }
  };
  dispatch({
    type: CompetencyRequestListPageActionTypes.SAVE_COMPETENCY_REQUEST_LIST_QUERY_PARAMS_TO_STORE,
    payload: queryParams
  });
};